import { CONFIG } from '../config.js';
import { computeAccelerations } from './gravity.js';

/**
 * One Velocity Verlet step with exponential damping.
 * hooks.afterBody(body, dt) optional (e.g. trail sample)
 */
export function physicsStep(bodies, dt, hooks = {}, config = CONFIG) {
  for (let i = 0; i < bodies.length; i++) {
    const b = bodies[i];
    b.velocity.x += 0.5 * b.accel.x * dt;
    b.velocity.y += 0.5 * b.accel.y * dt;
    b.velocity.z += 0.5 * b.accel.z * dt;
    b.position.x += b.velocity.x * dt;
    b.position.y += b.velocity.y * dt;
    b.position.z += b.velocity.z * dt;
  }

  computeAccelerations(bodies, config);

  const damp = Math.exp(-config.DAMPING_GAMMA * dt);
  for (let i = 0; i < bodies.length; i++) {
    const b = bodies[i];
    b.velocity.x = (b.velocity.x + 0.5 * b.accel.x * dt) * damp;
    b.velocity.y = (b.velocity.y + 0.5 * b.accel.y * dt) * damp;
    b.velocity.z = (b.velocity.z + 0.5 * b.accel.z * dt) * damp;
    if (typeof b.updateMesh === 'function') b.updateMesh();
    if (hooks.afterBody) hooks.afterBody(b, dt);
  }
}

/**
 * Fixed-substep advance. timeScale only multiplies how much sim time is requested;
 * never inflates the integrator dt.
 */
export function advanceSimulation(bodies, accumulator, timeScale, frameDelta, hooks = {}, config = CONFIG) {
  let acc = accumulator;
  let steps = 0;
  let simDt = 0;

  if (timeScale > 0) {
    acc += frameDelta * timeScale;
    while (acc >= config.FIXED_DT && steps < config.MAX_SUBSTEPS) {
      physicsStep(bodies, config.FIXED_DT, hooks, config);
      acc -= config.FIXED_DT;
      simDt += config.FIXED_DT;
      steps++;
    }
    if (steps === config.MAX_SUBSTEPS) acc = 0;
  }

  return { accumulator: acc, steps, simDt };
}
